<script setup lang="ts">
import { DecisionStatusEnum } from "../api.generated";
import {
  formatDecisionStatus,
  decisionStylePicker,
} from "../utils/decisionStatus";

const { decision } = defineProps<{
  decision: DecisionStatusEnum;
}>();

const decisionStyle = decisionStylePicker(decision);
</script>
<template>
  <div
    :class="[
      'pill mr-4 inline-flex justify-center rounded-full px-3 py-1.5 text-center font-sans text-sm no-underline',
      decisionStyle,
    ]"
  >
    <span>{{ formatDecisionStatus(decision) }}</span>
  </div>
</template>

<style scoped>
.pill {
  min-width: 100px;
}
</style>
